import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';

export default function Services() {
  const services = [
    {
      title: 'الإنشاءات والطرق',
      description: 'تسوية، حفر، طبقات أساس، صب خرسانة وأسفلت، دهانات وعلامات، أرصفة وإنترلوك، تمديدات كهرباء وإنارة، شبكات ماء وصرف واتصالات',
      icon: 'ri-road-map-line',
      path: '/services/construction',
      image: 'Modern highway construction with concrete laying equipment and road infrastructure in Kuwait, professional construction site with heavy machinery and precise engineering work, corporate clean background&width=500&height=300&seq=infra-main&orientation=landscape'
    },
    {
      title: 'البترول والطاقة',
      description: 'توريد معدات ومواد، عمليات O&M، خطوط أنابيب وخزانات وفق معايير API 650/653، فحوص NDT، وخدمات لوجستية متكاملة',
      icon: 'ri-oil-line',
      path: '/services/oil',
      image: 'Oil and gas facilities with storage tanks and pipeline infrastructure, petroleum industry equipment with safety standards, professional industrial background in Kuwait&width=500&height=300&seq=petro-main&orientation=landscape'
    },
    {
      title: 'تجارة الذهب والمعادن',
      description: 'تجارة السبائك وDore، فحص وصهر بمعايير سويسرية، شفافية كاملة في سلسلة التوريد، والالتزام بمعايير KYC/AML',
      icon: 'ri-coins-line',
      path: '/services/gold',
      image: 'Gold bars and precious metals trading with Swiss quality standards, luxury precious metals with professional certification and quality assurance, clean elegant background&width=500&height=300&seq=gold-main&orientation=landscape'
    },
    {
      title: 'التسليح والمعدات الدفاعية',
      description: 'أنظمة مضادة للمسيرات، درون مراقبة، مركبات مصفحة، أجهزة كشف وتتبع مع الالتزام بالضوابط التصديرية وشهادات المستخدم النهائي',
      icon: 'ri-shield-line',
      path: '/services/defense',
      image: 'Advanced defense equipment and surveillance systems, military grade technology with armored vehicles and detection systems, professional security background&width=500&height=300&seq=defense-main&orientation=landscape'
    },
    {
      title: 'الاستشارات',
      description: 'دراسات الجدوى الفنية والمالية، إدارة المخاطر والعقود، استراتيجيات التوسع الصناعي واللوجستي والدفاعي',
      icon: 'ri-lightbulb-line',
      path: '/services/consulting',
      image: 'Professional business consulting meeting with strategic planning documents, corporate boardroom with financial charts and analysis, modern office environment&width=500&height=300&seq=consult-main&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen" dir="rtl">
      <Header />
      
      {/* Breadcrumb */}
      <div className="bg-gray-50 py-4">
        <div className="container mx-auto px-4">
          <nav className="flex items-center text-sm text-gray-600">
            <Link to="/" className="hover:text-[#E71B25] transition-colors">
              الرئيسية
            </Link>
            <i className="ri-arrow-left-s-line mx-2"></i>
            <span className="text-[#595A5C] font-medium">الخدمات</span>
          </nav>
        </div>
      </div>
      
      <main className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h1 className="text-5xl font-bold text-[#595A5C] mb-6">خدماتنا</h1>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              نقدم مجموعة شاملة ومتنوعة من الخدمات المتخصصة التي تلبي احتياجات السوق الكويتي والخليجي، 
              مع الالتزام بأعلى معايير الجودة والاحترافية في التنفيذ
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {services.map((service, index) => (
              <Card key={index} className="h-full flex flex-col group hover:shadow-xl transition-all duration-300">
                <div className="mb-6 overflow-hidden rounded-lg">
                  <img
                    src={`https://public.readdy.ai/ai/img_res/948a13f1eb402f8ff16472e217608fb6.jpg${service.image}`}
                    alt={service.title}
                    className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                
                <div className="flex items-center mb-4">
                  <div className="w-16 h-16 bg-[#E71B25] rounded-xl flex items-center justify-center ml-4 group-hover:bg-[#d11620] transition-colors duration-300">
                    <i className={`${service.icon} text-white text-2xl`}></i>
                  </div>
                  <h2 className="text-2xl font-bold text-[#595A5C] group-hover:text-[#E71B25] transition-colors duration-300">
                    {service.title}
                  </h2>
                </div>
                
                <p className="text-gray-600 mb-8 flex-grow leading-relaxed text-lg">
                  {service.description}
                </p>
                
                <Link to={service.path}>
                  <Button variant="primary" size="md" className="w-full">
                    اقرأ المزيد
                    <i className="ri-arrow-left-line mr-2"></i>
                  </Button>
                </Link>
              </Card>
            ))}
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}